
import Vue from 'vue'
import CalendarIcon from '@/assets/svgs/calendar_today_icon.svg?inline'
import variables from '@/scss/variables.scss'
import { toRef } from '@vue/composition-api'

export default Vue.extend({
  name: 'DatePicker',
  created: function () {
    window.addEventListener('resize', this.onResize)
  },
  destroyed: function () {
    window.removeEventListener('resize', this.onResize)
  },
  beforeMount: function () {
    this.onResize()
  },
  methods: {
    onResize: function () {
      if (window.innerWidth < variables.md) {
        this.target = '.q-input'
        this.anchor = 'bottom middle'
        this.self = 'top middle'
      } else {
        this.target = true
        this.anchor = 'bottom left'
        this.self = 'top left'
      }
    },
  },
  components: {
    CalendarIcon
  },
  props: {
    value: String,
    inputName: {
      type: String,
      required: false,
      default: ''
    },
    rules: Array,
  },
  data: function () {
    return {
      isCalendarShowing: false,
      target: true as string | boolean,
      anchor: 'bottom left',
      self: 'top left',
    }
  },
})
